import React, { useEffect, useState } from 'react';
const DEADLINE = new Date('2026-08-10T23:59:00').getTime();
type TimeLeft = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
};
function getTimeLeft(): TimeLeft | null {
  const diff = DEADLINE - Date.now();
  if (diff <= 0) return null;
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor(diff / 3600000 % 24),
    minutes: Math.floor(diff / 60000 % 60),
    seconds: Math.floor(diff / 1000 % 60)
  };
}
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft | null>(getTimeLeft);
  useEffect(() => {
    const interval = window.setInterval(() => setTimeLeft(getTimeLeft()), 1000);
    return () => clearInterval(interval);
  }, []);
  if (!timeLeft) {
    return <div className="w-full rounded-2xl bg-rosa/10 px-6 py-5 text-center" data-id="element-1" data-mp="34qrz0psvh0ad">
        <p className="font-serif text-xl font-semibold text-rosa-dark" data-id="element-2" data-mp="34pyxq4con2zm">
          La oferta ha finalizado
        </p>
      </div>;
  }
  const blocks: Array<{
    value: number;
    label: string;
  }> = [{
    value: timeLeft.days,
    label: 'Días'
  }, {
    value: timeLeft.hours,
    label: 'Hrs'
  }, {
    value: timeLeft.minutes,
    label: 'Min'
  }, {
    value: timeLeft.seconds,
    label: 'Seg'
  }];
  return <div className="w-full rounded-2xl bg-rosa/10 px-4 py-5 sm:px-6" data-id="element-3" data-mp="124bujfund1ue">
      <ul className="grid grid-cols-4 gap-2 sm:gap-3" data-id="element-4" data-mp="172n8a1o2bwhw">
        {blocks.map(block => <li key={block.label} className="rounded-xl bg-white/70 px-2 py-3 text-center" data-id="element-5" data-mp="1us7q2h8hcnpl">
            <span className="block font-serif text-3xl font-semibold leading-none text-rosa-dark sm:text-4xl" data-id="element-6" data-mp="1zppy85eoaywj">
              {String(block.value).padStart(2, '0')}
            </span>
            <span className="mt-1.5 block text-[10px] font-medium uppercase tracking-[0.16em] text-tinta/60" data-id="element-7" data-mp="1pz552xhrqml0">
              {block.label}
            </span>
          </li>)}
      </ul>
      <p className="mt-4 text-center text-xs text-tinta/60 sm:text-sm" data-id="element-8" data-mp="2ihskpxdzx9ep">
        Después de esta fecha el precio vuelve a $47 USD
      </p>
    </div>;
}